import { Action, Dispatch } from "redux";
import axios from "../../../../config/axiosInterceptor";
import { BASE_URLS, ENVIRONMENT_MODE } from "../../../../config/constants";
import * as action_types from "./constants";
import { UsersCreateType } from "./types";

const baseURL = BASE_URLS[ENVIRONMENT_MODE].REACT_APP_API_BASE_URL;

export const getUsersListing = (payload: UsersCreateType) => {
  return async (dispatch: Dispatch<Action>) => {
    try {
      const { data } = await axios.post(`${baseURL}getUsersListing`, payload);
      dispatch({
        type: action_types.USER_LISTING,
        payload: { data: data, loading: false },
      });
    } catch (error) {
      dispatch({
        type: action_types.USER_LISTING,
        payload: { loading: false },
      });
    }
  };
};

export const removeUsersListingData = () => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch({
      type: action_types.USER_LISTING,
      payload: { data: {}, loading: true },
    });
  };
};
